import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Menu,
  X,
  ChevronDown,
  Phone,
  Mail,
  MapPin,
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
} from "lucide-react";
import { InfoService } from "../../services/site/InfoService";
import { SiWhatsapp, SiX } from "react-icons/si";
import { SITE_LOGO } from "../../services/ImageService";

type SocialLinksProps = {
  facebook?: string;
  x?: string;
  twitter?: string;
  linkedin?: string;
  instagram?: string;
  whatsapp?: string;
};

const Footer: React.FC = () => {
  function SocialLinks({
    facebook,
    x,
    twitter,
    linkedin,
    instagram,
    whatsapp,
  }: SocialLinksProps) {
    return (
      <div className="social-links flex gap-3">
        {facebook && (
          <a
            href={facebook}
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook size={20} />
          </a>
        )}

        {x && (
          <a
            href={x}
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiX size={20} />
          </a>
        )}

        {twitter && (
          <a
            href={twitter}
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Twitter size={20} />
          </a>
        )}

        {linkedin && (
          <a
            href={linkedin}
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin size={20} />
          </a>
        )}

        {instagram && (
          <a
            href={instagram}
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={20} />
          </a>
        )}
        {whatsapp && (
          <a
            href={whatsapp}
            className="social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiWhatsapp size={20} />
          </a>
        )}
      </div>
    );
  }
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            {/* <div className="footer-logo">
              <div className="logo-icon">HDT</div>
              <div className="logo-text">
                <span className="logo-name">HDT Solutions</span>
                <span className="logo-tagline">Transforming Ideas into Digital Reality</span>
              </div>
            </div> */}
            <div className="footer-logo-image">
              <img src={SITE_LOGO} alt="HDT Solutions" />
            </div>
            <p className="footer-desc">
              Empowering businesses with cutting-edge AI and digital solutions
              since 2018.
            </p>
            <SocialLinks
              facebook={InfoService.social_media.facebook}
              x={InfoService.social_media.twitter}
              // twitter="https://twitter.com/jana"
              linkedin={InfoService?.social_media?.linkedin}
              instagram={InfoService.social_media.instagram}
              whatsapp={InfoService.social_media.whatsapp}
            />
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about-us">About Us</a>
              </li>
              <li>
                <a href="/ai-data-extraction">Products</a>
              </li>
              <li>
                <a href="/pricing">Pricing</a>
              </li>
              <li>
                <a href="/contact-us">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Our Products</h3>
            <ul className="footer-links">
              <li>
                <a href="/ai-data-extraction">AI Data Extraction</a>
              </li>
              <li>
                <a href="/intelligent-chatbot">Intelligent Chatbot</a>
              </li>
              <li>
                <a href="/digital-signature-solution">Digital Signature</a>
              </li>
              <li>
                <a href="/pdf-word-template-filling">PDF/Word Templates</a>
              </li>
              <li>
                <a href="/content-security-policy">Security Protection</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={18} />
                <span>{InfoService.mobile_no_1}</span>
              </li>
              <li>
                <Mail size={18} />
                <span>{InfoService.site_email}</span>
              </li>
              <li>
                <MapPin size={18} />
                <span>Hyderabad, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 HDT Solutions. All rights reserved.</p>
          <div className="footer-links-bottom">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-and-conditions">Terms of Service</a>
            <a href="/cookie-policy">Cookie Policy</a>
            {/* <a href="/cancellation-refund">Cancellation</a>
            <a href="/shipping-policy">Shipping</a> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
